module.exports = __webpack_public_path__ + "img/рз_29.c5a53b61.png";